/* CUSTOM KIYO 2026-10-02 — Shopseite v2 (sections/kiyo-shop-aufbauten.liquid).
   1. Preis-Filter: Knopf blendet die Aufbauten der anderen Preisstufen aus, nochmal tippen zeigt alle (05.10.2026).
   2. Handy: Linie unter der Filterleiste, sobald sie unter der Kopfzeile klebt.
   3. The chosen band lives in the URL (?preis=1|2|3, other parameters such as ?view= stay), so reload and back
      navigation restore it. Screen readers hear the result from the live region; texts come from Liquid (07.10.2026).
   Warenkorb läuft über den Schnellkauf-Knopf des Themes (quick-add-component), nicht über dieses Script. */
(() => {
  if (window.kiyoShopInit) return;
  window.kiyoShopInit = true;

  const PARAM = 'preis';

  const init = (root) => {
    const leiste = root.querySelector('.ksh__marken');
    const raster = root.querySelector('.ksh__raster');
    const knoepfe = [...root.querySelectorAll('[data-ksh-marke]')];
    if (!leiste || !raster || !knoepfe.length) return;
    const karten = [...raster.querySelectorAll('.ksh__karte[data-ksh-stufe]')];
    const status = root.querySelector('[data-ksh-status]');

    // Show only the builds of one price band (null = all) and mirror it in the button states.
    const zeige = (stufe) => {
      knoepfe.forEach((k) => k.setAttribute('aria-pressed', k.dataset.kshMarke === stufe ? 'true' : 'false'));
      karten.forEach((karte) => { karte.hidden = stufe !== null && karte.dataset.kshStufe !== stufe; });
    };

    // Keep the band in the address without a new history entry; the theme editor preview is left alone.
    const merke = (stufe) => {
      if (window.Shopify && window.Shopify.designMode) return;
      const url = new URL(window.location.href);
      if (stufe === null) url.searchParams.delete(PARAM); else url.searchParams.set(PARAM, stufe);
      window.history.replaceState(window.history.state, '', url);
    };

    knoepfe.forEach((knopf) => knopf.addEventListener('click', () => {
      const an = knopf.getAttribute('aria-pressed') !== 'true';
      const stufe = an ? knopf.dataset.kshMarke : null;
      zeige(stufe);
      merke(stufe);
      if (status) status.textContent = (an ? knopf.dataset.kshMeldung : status.dataset.kshAlle) || '';
      // When the grid start has scrolled above the (sticky) bar, bring the first result back into view.
      if (raster.getBoundingClientRect().top < leiste.getBoundingClientRect().bottom) {
        raster.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      }
    }));

    // Restore a band from the URL (reload, shared link) silently; an unknown band is dropped from the URL.
    const gemerkt = new URLSearchParams(window.location.search).get(PARAM);
    if (gemerkt !== null) {
      if (knoepfe.some((k) => k.dataset.kshMarke === gemerkt)) zeige(gemerkt); else merke(null);
    }

    // Phone: the filter bar sticks under the header; show its bottom line only while it sticks.
    const setze = () => {
      const kopf = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height')) || 0;
      const klebt = getComputedStyle(leiste).position === 'sticky' && leiste.getBoundingClientRect().top <= kopf + 1 && window.scrollY > 0;
      leiste.classList.toggle('ksh__marken--klebt', klebt);
    };
    window.addEventListener('scroll', setze, { passive: true });
    window.addEventListener('resize', setze, { passive: true });
    setze();
  };

  const start = () => document.querySelectorAll('.ksh--aufbauten').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', (e) => e.target.querySelectorAll('.ksh--aufbauten').forEach(init));
})();
